import { render, staticRenderFns } from "./smHeroSection.vue?vue&type=template&id=3e38d8f0&scoped=true&"
import script from "./smHeroSection.vue?vue&type=script&lang=js&"
export * from "./smHeroSection.vue?vue&type=script&lang=js&"
import style0 from "./smHeroSection.vue?vue&type=style&index=0&id=3e38d8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e38d8f0",
  null
  
)

export default component.exports